import React, { useEffect, useState } from 'react';
import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import '../../styles/permission.css';

interface ModulePermissionFormProps {
  moduleName: string;
  reset: boolean;
  selectedPermissions?: {
    create: boolean;
    read: boolean;
    write: boolean;
    delete: boolean;
    approve: boolean;
    confirm: boolean;
    available: boolean;
    issuannce: boolean;
    cancel: boolean;
  };
  initialPermissions?: {
    create: boolean;
    read: boolean;
    write: boolean;
    delete: boolean;
    approve: boolean;
    confirm: boolean;
    available: boolean;
    issuannce: boolean;
    cancel: boolean;
  };
  onPermissionChange: (permissions: { [p: string]: boolean }) => void;
}

const ModulePermissionForm: React.FC<ModulePermissionFormProps> = ({
  moduleName,
  reset,
  selectedPermissions,
  onPermissionChange,
}) => {
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    if (reset) {
      // Reset all permissions to false
      onPermissionChange({
        create: false,
        read: false,
        write: false,
        delete: false,
        approve: false,
        confirm: false,
        available: false,
        issuannce: false,
        cancel: false,
      });
    }
  }, [reset]);
  const handleSelectAllChange = (e: CheckboxChangeEvent) => {
    setSelectAll(e.target.checked);
    onPermissionChange({
      create: e.target.checked,
      read: e.target.checked,
      write: e.target.checked,
      delete: e.target.checked,
      approve: e.target.checked,
      confirm: e.target.checked,
      available: e.target.checked,
      issuannce: e.target.checked,
      cancel: e.target.checked,
    });
  };

  const handleChange = (permission: string) => (e: CheckboxChangeEvent) => {
    onPermissionChange({
      ...selectedPermissions,
      [permission]: e.target.checked,
    });
  };

  useEffect(() => {
    if (
      selectedPermissions &&
      Object.values(selectedPermissions).every((value) => value)
    ) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedPermissions]);

  return (
    <>
      <div className="flex flex-row justify-between p-4">
        <span className="w-2/6 font-semibold">
          <Checkbox checked={selectAll} onChange={handleSelectAllChange}>
            {moduleName}
          </Checkbox>
        </span>
        <span className="w-1/6 font-semibold">
          <Checkbox
            className="custom-read-checkbox"
            checked={selectedPermissions?.read || false}
            onChange={handleChange('read')}
          />
        </span>
        <span className="w-1/6 font-semibold">
          <Checkbox
            className="custom-create-checkbox"
            checked={selectedPermissions?.create || false}
            onChange={handleChange('create')}
          />
        </span>
        <span className="w-1/6 font-semibold">
          <Checkbox
            className="custom-edit-checkbox"
            checked={selectedPermissions?.write || false}
            onChange={handleChange('write')}
          />
        </span>
        <span className="w-1/6 font-semibold">
          <Checkbox
            className="custom-delete-checkbox"
            checked={selectedPermissions?.delete || false}
            onChange={handleChange('delete')}
          />
        </span>
        <span className="w-1/6 font-semibold">
          <Checkbox
            checked={selectedPermissions?.approve || false}
            onChange={handleChange('approve')}
          />
        </span>
        <span className="w-1/6 font-semibold">
          <Checkbox
            checked={selectedPermissions?.confirm || false}
            onChange={handleChange('confirm')}
          />
        </span>
        <span className="w-1/6 font-semibold">
          <Checkbox
            checked={selectedPermissions?.available || false}
            onChange={handleChange('available')}
          />
        </span>
        <span className="w-1/6 font-semibold">
          <Checkbox
            checked={selectedPermissions?.issuannce || false}
            onChange={handleChange('issuannce')}
          />
        </span>
        <span className="w-1/6 font-semibold">
          <Checkbox
            checked={selectedPermissions?.cancel || false}
            onChange={handleChange('cancel')}
          />
        </span>
      </div>
    </>
  );
};

export default ModulePermissionForm;
